
<div class="val-bandeau-application val-flex-conteneur val-flex-colonne val-couleur-texte val-couleur-fond-page">
  <div class="val-bandeau-application-global val-flex-conteneur">
    <div class="val-flex-conteneur val-couleur-fond">
      <val-fonte-icone  class="val-bandeau-application-icone val-fonte-icone-hover"
                        iconeCss="fas fa-bars"
                        (click)="OuvrirFermer()">
      </val-fonte-icone>
      <val-fonte-icone  class="val-bandeau-application-icone val-fonte-icone-hover"
                        iconeCss="fas fa-search fa-fw"
                        (click)="OuvrirFermerRecherche()">
      </val-fonte-icone>
      <div  class="val-bandeau-application-editeur-recherche val-flex-conteneur val-flex-colonne"
            [class.ouvert]="rechercheOuverte"
            [class.ferme]="!rechercheOuverte"
            [style.--largeur]="(barreNavigation!.largeur - 100) + 'px'">
        <div class="val-flex-1"></div>
        <kendo-textbox [placeholder]="'valcomposantslib.bandeau-application.rechercher.placeholder' | transloco"></kendo-textbox>
        <div class="val-flex-1"></div>
      </div>
      <val-fonte-icone  class="val-bandeau-application-icone val-fonte-icone-hover"
                        iconeCss="fas fa-star">
      </val-fonte-icone>
    </div>
    <svg class="val-bandeau-application-onglet val-couleur-fond-onglet"
         [ngClass]="{'val-invisible': utiliserFichesOuvertes}">
      <path d="M 0 45 V 0 H 38 C 12 10 26 42 0 45 Z"
            shape-rendering="geometricPrecision">
      </path>
    </svg>
    <svg class="val-bandeau-application-onglet val-couleur-fond-onglet"
         [ngClass]="{'val-invisible': !utiliserFichesOuvertes}">
      <path d="M 0 45 V 0 H 18 C 1 7 1 22 0 45 Z"
            shape-rendering="geometricPrecision">
      </path>
    </svg>
    <div class="val-flex-1 val-flex-conteneur">
      <val-simple-image [src]="srcLogo"
                        height="35">
      </val-simple-image>
      <val-simple-libelle class="val-bandeau-application-titre val-couleur-titre"
                          [libelle]="titre | val_libelle_dico: dicoTitre">
      </val-simple-libelle>
      <div class="val-flex-1"></div>
      <div class="val-bandeau-application-utilisateur val-flex-conteneur val-couleur-icone-standard">
        <div class="val-flex-1"></div>
        <div #iconeutilisateur
             class="val-flex-conteneur val-flex-colonne">
          <div class="val-flex-1"></div>
          <val-fonte-icone class="val-bandeau-application-icone-utilisateur"
                           iconeCss="fas fa-user">
          </val-fonte-icone>
          <val-simple-libelle class="val-bandeau-application-nom-utilisateur"
                              [libelle]="nomUtilisateur">
          </val-simple-libelle>
          <div class="val-flex-1"></div>
        </div>
        <kendo-contextmenu [target]="iconeutilisateur"
                           showOn="click"
                           [items]="items"
                           (select)="MenuClick($event)">
          <ng-template kendoMenuItemTemplate let-item="item">
            <div class="val-flex-conteneur">
              <val-fonte-icone [iconeCss]="item.icone"></val-fonte-icone>
              <div style="width: 4px;"></div>
              <val-simple-libelle class="val-flex-1" [libelle]="item.cle ? (item.cle | transloco) : item.texte"></val-simple-libelle>
            </div>
          </ng-template>
        </kendo-contextmenu>
        <div class="val-flex-1"></div>
      </div>
      <div class="val-bandeau-application-logo-editeur">
        <val-simple-image [src]="srcLogoEditeur"
                          height="35">
        </val-simple-image>
      </div>
    </div>
  </div>
  <div class="val-barre-fiches-ouvertes val-flex-conteneur"
       [ngClass]="{'val-invisible': !utiliserFichesOuvertes}">
    <div class="val-barre-fiches-ouvertes-panel val-flex-conteneur val-flex-colonne"
         [class.ouvert]="rechercheOuverte"
         [class.ferme]="!rechercheOuverte"
         [style.--largeur]="(barreNavigation!.largeur + 20) + 'px'">
      <div class="val-flex-1 val-couleur-fond "></div>
      <div class="val-flex-conteneur">
        <div class="val-flex-1 val-couleur-fond "></div>
        <div class="val-barre-fiches-ouvertes-panel-icon">
          <svg class="val-bandeau-application-onglet val-couleur-fond-onglet">
            <path d="M 0 28 V 0 H 18 C 18 23 20 28 0 28 Z"
                  shape-rendering="geometricPrecision">
            </path>
          </svg>
        </div>
      </div>
    </div>
    <div class="val-barre-fiches-ouvertes-items val-flex-1 val-flex-conteneur">
      <div class="val-barre-fiches-ouvertes-retour"
           (click)="AfficherPagePrincipale()">
        <val-fonte-icone iconeCss="far fa-window"></val-fonte-icone>
      </div>

      @for (donneesFicheEdition of DonneesFichesEdition; track $index) 
      {
        <div class="val-barre-fiches-ouvertes-item val-flex-conteneur"
             [ngClass]="{'val-barre-fiches-ouvertes-item-active': donneesFicheEdition.active}"
             (click)="OuvrirFiche(donneesFicheEdition)">
          <val-simple-libelle class="val-flex-1"
                              [libelle]="donneesFicheEdition.libelle">
          </val-simple-libelle>
          <div class="val-barre-fiches-ouvertes-item-icone val-flex-conteneur val-flex-colonne"
               (click)="FermerFiche(donneesFicheEdition)">
            <div class="val-flex-1"></div>
            <val-fonte-icone iconeCss="fas fa-times"></val-fonte-icone>
            <div class="val-flex-1"></div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
